/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React, { Component, PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Helmet from 'react-helmet';
import fetch from '../../core/fetch';
import s from './Realisations.css';
import HeightMatchingGroup from 'react-height-matching-group';
import { Link } from 'react-router';


const title = 'Réalisations';

@withStyles(s)
export default class Realisations extends Component {

    constructor(props) {
        super(props);

        this.state = {
            realisations: [],
            loader: true,
        };
    }

    componentDidMount() {

        this.GetRealisations();
    }

    async GetRealisations() {
        const resp = await fetch('/graphql', {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: '{realisations{id, slug, title, content, excerpt, thumb1, thumb2, thumb3, logo, banniere}}',
            }),
            credentials: 'include',
        });
        const { data } = await resp.json();
        if (!data || !data.realisations) throw new Error('Erreur sur le chargement des réalisations !');

        if(data){
            this.setState({ loader: false })
        }

        this.setState({ realisations: data.realisations })
    }

    render() {
        const appear = this.state.loader ? 'appear' : '';
        var background = {
            backgroundColor: '#ff8a00'
        }

        return (
            <div className={s.root}>
                <Helmet title={title} />
                <div className={`spinner ${appear}`} style={background} ></div>
                <div id="realisations" className={`realisations`}>
                    <div className={`bgHeader`}></div>
                    <main role="main">
                        <div className={`container`}>
                            <div className={`wrapTitle`}>
                                <span className={`smallTitle`}>Voici nos plus récentes</span>
                                <h1 className={`titrePage`}>{title}</h1>
                            </div>
                            <div className={`wrapRealisations`}>
                                <div className={`content`}>
                                    <ul>
                                    {this.state.realisations.map((item, index) => (
                                        <li key={index} className={`col-xs-12 col-sm-6 col-md-6 col-lg-4`}>
                                            <Link to={`/realisations/${item.slug}`}>
                                                <div className={`realisation match`}>
                                                    <div className={`thumbRealisation`}>
                                                        <div className={`blackBox`}>
                                                            <div className={`logoRealisation`}>
                                                                <img src={item.logo} alt="Logo pu projet" />
                                                            </div>
                                                        </div>
                                                        <img src={item.thumb3} alt="Image pu projet" />

                                                    </div>
                                                    <div className={`content`}>
                                                        <span className={`titreRealisation`}>{item.title}</span>
                                                        <span className={`texteRealisation`} dangerouslySetInnerHTML={{ __html: item.excerpt }} />
                                                    </div>
                                                    <span className={`lienRealisation`}>Consulter</span>
                                                </div>
                                            </Link>
                                        </li>
                                    ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./containers/realisations/realisations.js